import React, { useEffect, useState } from 'react';
import { Alert, Box, Tab, Tabs } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import {
  AssuntosMonitoringPanel,
  AgenciesMonitoringPanel,
  MonitorarAgenciasButton,
} from '../monitoring';

type Props = {
  tab?: 'assuntos' | 'agencies';
  onTabChange?: (tab: 'assuntos' | 'agencies') => void;
  onOpenAgencyMonitoring: () => void;
};

export function NotificationMonitoringSection({
  tab: tabProp,
  onTabChange,
  onOpenAgencyMonitoring,
}: Props) {
  const [internalTab, setInternalTab] = useState<'assuntos' | 'agencies'>('assuntos');
  const tab = tabProp ?? internalTab;

  useEffect(() => {
    if (tabProp) setInternalTab(tabProp);
  }, [tabProp]);

  const handleTabChange = (_: unknown, value: 'assuntos' | 'agencies') => {
    setInternalTab(value);
    onTabChange?.(value);
  };

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Estas escolhas disparam <strong>e-mail automático (D+1)</strong> e alertas no sininho quando houver mudanças
        compatíveis. Para assuntos, use também o filtro no{' '}
        <RouterLink to="/dashboard" style={{ fontWeight: 600 }}>
          Dashboard
        </RouterLink>
        .
      </Alert>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab value="assuntos" label="Assuntos" />
          <Tab value="agencies" label="Agências" />
        </Tabs>
      </Box>

      {tab === 'assuntos' && <AssuntosMonitoringPanel enabled />}

      {tab === 'agencies' && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <MonitorarAgenciasButton onClick={onOpenAgencyMonitoring} />
          </Box>
          <AgenciesMonitoringPanel enabled />
        </>
      )}
    </Box>
  );
}
